export { default } from "./Licenses";
